module.exports = __webpack_public_path__ + "static/media/team_presentation_.458da164.svg";